export const GET = 'GET';
export const POST = 'POST';
export const DELETE = 'DELETE';
